import React, { useRef } from "react";
import "./ReviewsSection.css";

function ReviewsSection() {
  const reviewsContainerRef = useRef(null);

  const reviews = [
    {
      text: "I’m so pleased with the results from my HIFU treatment. My skin feels firmer and looks more lifted, while still looking completely natural. The whole experience was lovely from start to finish",
      name: "Sarah M.",
      treatment: "HIFU FACE & NECK",
    },
    {
      text: "My skin felt so fresh and hydrated after my Hydrofacial. I noticed a real difference in my glow and texture, and the treatment was so relaxing. I’ll definitely be coming back",
      name: "Emma R",
      treatment: "Hydrofacial",
    },
    {
      text: "I was nervous about trying microneedling for the first time, but everything was explained so clearly. My skin looks smoother and brighter, and I’m really happy with the results.",
      name: "Chloe W.",
      treatment: "Microneedling",
    },
    {
      text: "Absolutely loved my treatment. The whole experience was comfortable and professional.",
      name: "Noha",
      treatment: "MICRONEEDLING",
    },
    {
      text: "I wanted something subtle to improve my skin rather than change my features. The skin booster has made my skin look much more hydrated and refreshed. I absolutely love the result",
      name: "Sophie T.",
      treatment: "Lumi Pro Skin Booster",
    },
    {
      text: "Such a professional and friendly experience. I’ve noticed my skin feels tighter and more defined, and I love that the results still look natural. I’m really happy I chose this treatment",
      name: "Jessica P.",
      treatment: "HIFU – Face & Neck",
    },
  ];

  const scrollReviews = () => {
    if (reviewsContainerRef.current) {
      reviewsContainerRef.current.scrollBy({
        left: 380,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="reviews-section">

      {/* Header */}
      <div className="reviews-header">

        <div>
          <div className="reviews-label">
            <span className="reviews-line"></span>
            <span>KIND WORDS</span>
          </div>

          <h2 className="reviews-title">
            In our clients' <span>own words</span>
          </h2>
        </div>

        {/* Right Button */}
        <button
          className="reviews-next-btn"
          onClick={scrollReviews}
          aria-label="See more reviews"
        >
          <span>SEE MORE REVIEWS</span>
          <span className="arrow">→</span>
        </button>

      </div>

      {/* Rolling Reviews */}
      <div
        className="reviews-container"
        ref={reviewsContainerRef}
      >
        {reviews.map((review, index) => (
          <div className="review-card" key={index}>

            {/* Stars */}
            <div className="review-stars">
              ★ ★ ★ ★ ★
            </div>

            {/* Review */}
            <p className="review-text">
              “{review.text}”
            </p>

            {/* Divider */}
            <div className="review-divider"></div>

            {/* Client */}
            <div className="review-client">
              <h3>{review.name}</h3>
              <p>{review.treatment}</p>
            </div>

          </div>
        ))}
      </div>

    </section>
  );
}

export default ReviewsSection;